/* FENN: lembrar o último tamanho escolhido pelo cliente POR CATEGORIA e já vir marcado nos outros
 * produtos daquela mesma categoria (14/09/2026, pedido do Leonardo, corrigido no mesmo dia: "camisa
 * M, calça P e moletom G" têm que ser lembrados SEPARADOS, não um tamanho único pra loja inteira).
 * A "categoria" usada é o Tipo de produto do Shopify (product.type - Camiseta, Calça, Moletom...),
 * já cadastrado em cada produto; lido de main[data-template='product'][data-product-type], escrito
 * em layout/theme.liquid. Guarda no localStorage do navegador (não é cookie, não precisa de
 * aviso/consentimento - é uma preferência funcional do próprio site, não rastreamento; a loja hoje
 * também não tem nenhum aviso de cookie configurado). Continua valendo depois de fechar e abrir o
 * navegador de novo (localStorage não expira sozinho, diferente de um dado só "desta visita").
 * Fase 1 (esta): dura enquanto o cliente usa o MESMO navegador/aparelho. Fase 2 (futura, se o
 * Leonardo pedir): gravar isso numa conta de cliente logada, pra valer em qualquer aparelho.
 *
 * Não mexe na opção "Cor" (isso é assets/fenn-produto.js); só a opção "Tamanho"/"Size". Reaplica
 * sozinho sempre que o formulário de variante for redesenhado (troca de cor, chegada numa página
 * de produto nova) - idempotente e religado por MutationObserver, mesmo padrão de fenn-produto.js. */
(function () {
  var PREFIXO_CHAVE = 'fenn_tamanho_preferido:';
  var CATEGORIA_SEM_TIPO = '_sem_categoria'; // produto cadastrado sem "Tipo" no Shopify
  var NOMES_OPCAO_TAMANHO = ['tamanho', 'size'];

  function categoriaAtual() {
    var main = document.querySelector("main[data-template='product']");
    var tipo = main ? (main.dataset.productType || '').trim() : '';
    return tipo || CATEGORIA_SEM_TIPO;
  }

  function nomeDoInput(input) {
    return (input.getAttribute('aria-label') || input.value || '').replace(/ - .*/, '').trim();
  }

  function salvarPreferencia(fieldset) {
    var marcado = fieldset.querySelector('input:checked');
    if (!marcado) return;
    var tamanho = nomeDoInput(marcado);
    if (!tamanho) return;
    try {
      localStorage.setItem(PREFIXO_CHAVE + categoriaAtual(), tamanho);
    } catch (e) {
      // Navegador privado/bloqueado: sem memória entre páginas, mas nada quebra.
    }
  }

  function aplicarPreferencia(fieldset) {
    var preferido;
    try {
      preferido = localStorage.getItem(PREFIXO_CHAVE + categoriaAtual());
    } catch (e) {
      return;
    }
    if (!preferido) return;

    var marcadoAtual = fieldset.querySelector('input:checked');
    if (marcadoAtual && nomeDoInput(marcadoAtual) === preferido) return; // já está no tamanho certo

    var labels = fieldset.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      var input = labels[i].querySelector('input');
      if (!input || input.disabled) continue;
      if (nomeDoInput(input) === preferido) {
        // Clique de verdade no rádio: dispara o mesmo caminho nativo do tema (Section Rendering
        // API), então preço, disponibilidade e o ID que vai pro carrinho ficam sempre corretos -
        // não é um truque visual à parte.
        input.click();
        return;
      }
    }
  }

  function ligarGrupo(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (!legend) return;
    var nomeOpcao = (legend.textContent || '').trim().toLowerCase();
    if (NOMES_OPCAO_TAMANHO.indexOf(nomeOpcao) === -1) return;

    if (!fieldset.dataset.fennTamanhoLigado) {
      fieldset.dataset.fennTamanhoLigado = '1';
      fieldset.addEventListener('change', function () {
        salvarPreferencia(fieldset);
      });
    }

    aplicarPreferencia(fieldset);
  }

  function ligar() {
    document.querySelectorAll("main[data-template='product'] fieldset.variant-option--buttons").forEach(ligarGrupo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
  new MutationObserver(ligar).observe(document.documentElement, { childList: true, subtree: true });
})();
